import { ExportToCsv } from 'export-to-csv'

/**
 * Exports data as a CSV file and downloads it
 * @param data - Array of objects to export (each object will be a row in the CSV)
 * @param title - CSV file title/filename
 */
const downloadCSV = <T extends Record<string, any>>(
  data: T[],
  title: string
): void => {
  const options = {
    fieldSeparator: ';',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: false,
    showTitle: false,
    title: title,
    filename: title,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true
    // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
  }
  const csvExporter = new ExportToCsv(options)
  csvExporter.generateCsv(data)
}

export default downloadCSV
